import { Middleware } from "redux";

import { Attachment } from "@com.mgmtp.a12.dataservices/dataservices-access/lib/Attachment/attachment";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { isRecord } from "../utilities/typeGuardUtils";

export const filterEmptyAttachmentsMiddleware: Middleware<unknown, { locale: Locale }> = api => next => action => {
	if (FormEngineActions.event.match(action)) {
		if (
			Events.attachmentValueChange.match(action.payload.engineEvent) &&
			isEmptyAttachment(action.payload.engineEvent.payload.value)
		) {
			return;
		}

		if (Events.Repeat.multiFileUpload.match(action.payload.engineEvent)) {
			const filteredToBeAdded = action.payload.engineEvent.payload.toBeAdded.filter(it => !isEmptyAttachment(it));
			const filteredToBeReplaces = (action.payload.engineEvent.payload.toBeReplaced ?? []).filter(
				it => !isEmptyAttachment(it.value)
			);

			if (filteredToBeAdded.length === 0 && filteredToBeReplaces.length === 0) {
				return;
			}

			return next(
				FormEngineActions.event({
					activityId: action.payload.activityId,
					engineEvent: Events.Repeat.multiFileUpload({
						...action.payload.engineEvent.payload,
						toBeAdded: filteredToBeAdded,
						toBeReplaced: filteredToBeReplaces
					})
				})
			);
		}
	}

	return next(action);
};

export function isEmptyAttachment(value: unknown): value is Attachment {
	return isRecord(value) && value.attachment_id === null && value.content === null;
}
